import { provision } from '@wix/ambassador-funnel-intro-v1-meta-site-provision-descriptor/http'
import { ProvisionRequest } from '@wix/ambassador-funnel-intro-v1-meta-site-provision-descriptor/types'
import { retry } from '@wix/funnel-utils'

import { withMonitoring } from '../../monitoring/withMonitoring'
import { ambassadorHttpClient } from '../httpClient'

export const provisionMetasite = async (params: ProvisionRequest) => {
  const request = () => ambassadorHttpClient.request(provision(params))
  // Monitoring must wrap retry (not the other way around) so the FedOps interaction
  // counts one start/end per user provisioning instead of one per retry attempt.
  const requestWithRetry = () => retry(request)
  return withMonitoring(requestWithRetry, 'provisionMetasite')
}
